<template>
  <router-link to="/"></router-link>
  <router-link to="/scorecard"></router-link>
  <router-link to="/signup"></router-link>
  <router-view></router-view>
</template>


<style>
html,
body {
  background-color: #EFEFED;
  height: 100%;
  margin: 0;
}
</style>